import { isEmpty } from 'lodash';

import useDonations from 'hb-react/shared/apps/Donations/hooks/useDonations';
import * as mobileDeviceFromUserAgent from 'helpers/mobileDeviceFromUserAgent';

const useImmersiveMenu = ({ network, location }) => {
  const { donations } = useDonations({
    enabled: location?.pathname?.includes('/donations/'),
  });

  const topicsConfig = network?.features?.topics?.config;
  const donationsConfig = network?.features?.donations?.config;
  const donationCampaigns = donations?.campaigns || [];

  return immersiveMenu({
    location,
    topicsConfig,
    donationsConfig,
    donationCampaigns,
  });
};

export const immersiveMenu = ({
  location,
  topicsConfig,
  donationsConfig,
  donationCampaigns,
}) => {
  // Immersive not enable on mobile
  if (mobileDeviceFromUserAgent.any()) {
    return false;
  }
  // Immersive groups
  if (
    !!topicsConfig?.immersive_menu_enabled &&
    !!topicsConfig?.advanced_options_enabled &&
    location?.pathname.includes('/topics/') &&
    !location?.pathname.includes('/my-mentoring')
  ) {
    return true;
  }
  // Immersive donation campaigns
  if (
    !!donationsConfig?.advanced_options_enabled &&
    !isEmpty(donationCampaigns) &&
    location?.pathname.includes('/donations/') &&
    actualDonationCampaignIsImmersive(donationCampaigns, location)
  ) {
    return true;
  }

  return false;
};

const actualDonationCampaignIsImmersive = (donationCampaigns, location) => {
  const immersiveCampaign = donationCampaigns.find(
    (campaign) =>
      location?.pathname.includes(campaign.id) && campaign.immersive_mode,
  );

  return !isEmpty(immersiveCampaign);
};

export const ImmersiveMenu = ({ location, children, network }) => {
  const isImmersiveMenu = useImmersiveMenu({ location, network });

  return children({ isImmersiveMenu });
};

export default useImmersiveMenu;
